
export default class EventsContainer<T> {

    protected events = new Map<string, ((o: T, e: HTMLElement) => void)[]>();

    protected obj: T;

    protected elem: HTMLElement;

    constructor(obj: T, elem: HTMLElement) {
        this.obj = obj;
        this.elem = elem;
    }

    public register(name:string, event: ((a: T, e: HTMLElement) => void)) {
        if(!this.events.has(name)){
            this.events.set(name, []);
        }

        this.events.get(name).push(event);
    }

    public call(name:string){

        if(this.events.has(name)){

            this.events.get(name).forEach(callback => {
                callback(this.obj, this.elem);
            });

        }

    }


}